const BASE_URL = 'https://nathnagribareilly.com';
const LOGO_URL = `${BASE_URL}/images/nathnagri-bareilly-logo_full.png`;

export const generateGlobalSchema = () => {
  return [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Nath Nagri Bareilly",
      "alternateName": "NathNagri Bareilly",
      "url": BASE_URL,
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${BASE_URL}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Nath Nagri Bareilly",
      "url": BASE_URL,
      "logo": LOGO_URL
    }
  ];
};

export const generateHomeItemListSchema = (temples = []) => {
  if (!temples || temples.length === 0) return null;
  const topTemples = temples.slice(0, 10);
  
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": topTemples.map((temple, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": temple.name,
      "url": `${BASE_URL}/temple/${temple.id || temple.slug}`
    }))
  };
};

export const generateTempleSchema = (temple, currentUrl) => {
  if (!temple) return null;
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "HinduTemple", // Or Place if HinduTemple isn't fully supported, but HinduTemple is valid.
    "name": temple.name,
    "description": temple.seo_description || temple.description,
    "url": currentUrl || `${BASE_URL}/temple/${temple.id || temple.slug}`,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": temple.location,
      "addressLocality": "Bareilly",
      "addressRegion": "Uttar Pradesh",
      "addressCountry": "India"
    }
  };

  // Add image if available
  if (temple.image || (temple.images && temple.images.length > 0)) {
     schema.image = temple.image || temple.images[0];
     if (!schema.image.startsWith('http')) {
       schema.image = `${BASE_URL}${schema.image}`;
     }
  }

  // Add timings if available
  if (temple.morning_timing || temple.evening_timing) {
    schema.openingHours = [];
    if (temple.morning_timing) schema.openingHours.push(temple.morning_timing);
    if (temple.evening_timing) schema.openingHours.push(temple.evening_timing);
  }

  return schema;
};

export const generateBlogSchema = (blog, currentUrl) => {
  if (!blog) return null;
  
  let imageUrl = blog.image;
  if (imageUrl && !imageUrl.startsWith('http')) {
     imageUrl = `${BASE_URL}${imageUrl}`;
  }

  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": blog.title,
    "description": blog.excerpt || (blog.content ? blog.content.replace(/<[^>]+>/g, '').substring(0, 160) : ""),
    "image": imageUrl || LOGO_URL,
    "author": {
      "@type": "Person",
      "name": blog.author || "Guest"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Nath Nagri Bareilly",
      "logo": {
        "@type": "ImageObject",
        "url": LOGO_URL
      }
    },
    "datePublished": blog.datePublished || blog.date || new Date().toISOString(),
    "dateModified": blog.dateModified || blog.date || new Date().toISOString(),
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": currentUrl || `${BASE_URL}/blog/${blog.slug || blog.id}`
    }
  };
};

export const generateAboutOrganizationSchema = (aboutData, currentUrl) => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Nath Nagri Bareilly",
    "description": aboutData?.metaDescription || "Bareilly is known as Nath Nagri. Discover the history and divine spiritual temples of Bareilly.",
    "url": BASE_URL,
    "logo": LOGO_URL,
    "sameAs": [
      // Add social media links here if available in the future
      "https://www.facebook.com/nathnagrtibareilly", // Example
    ]
  };
};

export const generateBreadcrumbSchema = (paths = []) => {
  if (!paths || paths.length === 0) return null;

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": paths.map((path, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": path.name,
      "item": `${BASE_URL}${path.url}`
    }))
  };
};

export const generateFAQSchema = (faqs = []) => {
  if (!faqs || faqs.length === 0) return null;

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
};

export const generateWebPageSchema = (pageType = "WebPage", data = {}, currentUrl = "") => {
  return {
    "@context": "https://schema.org",
    "@type": pageType,
    "name": data.name || "Nath Nagri Bareilly",
    "description": data.description || "Bareilly is known as Nath Nagri. Discover the history and divine spiritual temples of Bareilly.",
    "url": currentUrl || BASE_URL,
  };
};
